import React from 'react';
import i18n from '@yandex-int/i18n';
import { Channel } from 'client/model/skill';
import { SmartScreenIcon } from './SmartScreenIcon';
import { TvIcon } from './TvIcon';
import * as keyset from 'i18n/SkillsIndex';
import * as skillCreationKeyset from 'i18n/SkillCreation';

const t = i18n(keyset);
const tSkillCreation = i18n(skillCreationKeyset);

export const mapChannelToInstallableAppCard: Record<
    Exclude<Channel, Channel.Thereminvox>,
    {
        icon: React.JSX.Element | null;
        label: string;
    }
> = {
    [Channel.AliceSkill]: {
        icon: null,
        label: tSkillCreation('alice-skill'),
    },
    [Channel.AutoApp]: {
        icon: <SmartScreenIcon />,
        label: t('auto-app'),
    },
    [Channel.SmartHome]: {
        icon: null,
        label: tSkillCreation('smart-home'),
    },
    [Channel.SmartScreenApp]: {
        icon: <SmartScreenIcon />,
        label: t('smart-screen'),
    },
    [Channel.TvApp]: {
        icon: <TvIcon />,
        label: t('tv'),
    },
};
